// extracted by mini-css-extract-plugin
export var webContainer = "web-module--webContainer--LlTHb";
export var web0 = "web-module--web0--+e-x5";
export var web1 = "web-module--web1--O-hn3";